import { render } from "./candidate-reference-rating.fieldset.vue?vue&type=template&id=597d5588"
import script from "./candidate-reference-rating.fieldset.vue?vue&type=script&lang=js"
export * from "./candidate-reference-rating.fieldset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QRating from 'quasar/src/components/rating/QRating.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRating,QTooltip,QInput});
